import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'SKILL_UPDATE',
    smsDelete : 'SKILL_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        skill: [],

        submitSuccess: false,
        skillLoading: false,
        skillError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SKILL(state, skill) {
            state.skill = skill;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SKILL_LOADING (state, loading) {
            state.skillLoading = loading;
        },

        SKILL_ERROR (state, hasError) {
            state.skillError = hasError;
        }
    },

    actions: {
        async addSkill ({commit, dispatch}, payload) {
            commit('SKILL_LOADING', true);
            commit('SKILL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_skill, payload.skill, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchSkill')
                return response

            } catch (e) {
                commit('SKILL_ERROR', true);
            } finally {
                commit('SKILL_LOADING', false);
            }
        },

        async fetchSkill ({ commit }) {
            commit('SKILL_LOADING', true);
            commit('SKILL_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.skill_list, config);
                let response = result.data
                commit('SET_SKILL', response.data);

            } catch(error) {
                commit('SKILL_ERROR', true);
            } finally {
                commit('SKILL_LOADING', false);
            }
        },

        async updateSkill ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_skill + payload.id, payload.skill, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchSkill')
                return response

            } catch (e) {
                commit('SKILL_ERROR', true);
            } finally {
                commit('SKILL_LOADING', false);
            }
        },
        
        async deleteSkill({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.skill_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchSkill')
            return response
        }
    },

    getters: {}
}
